export const WEBSITE_BASE = 'http://localhost:3000'
export const BLOCK_EXPLORER = 'https://starkscan.co/'
export const API_BASE_URL = 'https://api.expectium.io'
export const SHARES_LATEST_STATE = 1;
export const DOCUMENTATION_BULB = 'https://docs.expectium.io'